import { render } from "./AddLdapAccount.vue?vue&type=template&id=476cd4c8&scoped=true"
import script from "./AddLdapAccount.vue?vue&type=script&lang=js"
export * from "./AddLdapAccount.vue?vue&type=script&lang=js"

import "./AddLdapAccount.vue?vue&type=style&index=0&id=476cd4c8&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476cd4c8"]])

export default __exports__